<template>
  <div class="signup-step">
    <h2>
      {{ t('step3_title_prefix') }}<span class="grad">{{ t('step3_title_grad') }}</span
      >{{ t('step3_title_suffix') }}
    </h2>

    <div class="sub-section">
      <span class="field-label">{{ t('lbl_gender') }}</span>
      <div
        class="pill-row"
        role="radiogroup"
      >
        <button
          type="button"
          class="pill"
          :class="{ selected: gender === 'male' }"
          :aria-checked="gender === 'male'"
          role="radio"
          @click="$emit('update:gender', 'male')"
        >
          {{ t('gender_male') }}
        </button>
        <button
          type="button"
          class="pill"
          :class="{ selected: gender === 'female' }"
          :aria-checked="gender === 'female'"
          role="radio"
          @click="$emit('update:gender', 'female')"
        >
          {{ t('gender_female') }}
        </button>
      </div>
    </div>

    <div class="sub-section">
      <span class="field-label">{{ t('lbl_pref') }}</span>
      <div class="pill-row">
        <button
          type="button"
          class="pill"
          :class="{ selected: preferredGender === 'female' }"
          @click="$emit('update:preferredGender', 'female')"
        >
          {{ t('pref_female') }}
        </button>
        <button
          type="button"
          class="pill"
          :class="{ selected: preferredGender === 'male' }"
          @click="$emit('update:preferredGender', 'male')"
        >
          {{ t('pref_male') }}
        </button>
        <button
          type="button"
          class="pill"
          :class="{ selected: preferredGender === 'all' }"
          @click="$emit('update:preferredGender', 'all')"
        >
          {{ t('pref_all') }}
        </button>
      </div>
    </div>

    <div class="sub-section">
      <span class="field-label">{{ t('lbl_age_range') }}</span>
      <div class="range-block">
        <div class="range-values">
          <span
            ><strong>{{ ageFrom }}</strong
            ><span class="lbl">{{ t('age_years') }}</span></span
          >
          <span
            ><span class="lbl">{{ t('age_to') }}</span
            ><strong>{{ ageTo }}</strong
            ><span class="lbl">{{ t('age_years') }}</span></span
          >
        </div>
        <div class="range-track">
          <div
            class="range-fill"
            :style="rangeFillStyle"
          >
          </div>
          <input
            :value="ageFrom"
            type="range"
            :min="AGE_MIN"
            :max="AGE_MAX"
            step="1"
            :aria-label="t('lbl_age_range')"
            @input="onAgeInput($event, 'from')"
          />
          <input
            :value="ageTo"
            type="range"
            :min="AGE_MIN"
            :max="AGE_MAX"
            step="1"
            :aria-label="t('lbl_age_range')"
            @input="onAgeInput($event, 'to')"
          />
        </div>
        <div class="range-note">{{ t('age_note') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { i18nMixin } from '../helpers';
import { AGE_MIN, AGE_MAX, clampAgeRange } from '../signupConfig';

export default {
  name: 'MatchingStep',
  mixins: [i18nMixin],
  props: {
    gender: { type: String, default: null },
    preferredGender: { type: String, default: null },
    ageFrom: { type: Number, required: true },
    ageTo: { type: Number, required: true },
  },
  data() {
    return {
      AGE_MIN,
      AGE_MAX,
    };
  },
  computed: {
    rangeFillStyle() {
      const span = AGE_MAX - AGE_MIN;
      const l = ((this.ageFrom - AGE_MIN) / span) * 100;
      const r = ((this.ageTo - AGE_MIN) / span) * 100;
      return { left: l + '%', width: r - l + '%' };
    },
  },
  methods: {
    // Normalize the moved thumb against the other end and push both values up.
    // Emitting both is harmless — .sync just re-assigns each on the parent.
    onAgeInput(event, which) {
      const raw = parseInt(event.target.value, 10);
      const next =
        which === 'from'
          ? clampAgeRange(raw, this.ageTo, 'from')
          : clampAgeRange(this.ageFrom, raw, 'to');
      this.$emit('update:ageFrom', next.from);
      this.$emit('update:ageTo', next.to);
    },
  },
};
</script>
